import Navbar from "../component/landingPage/navigation/Navbar";

import HeroSection from "../component/landingPage/heroSection/HeroSection";

import "../asset/sass/global.scss";

import background from "../asset/lotties/bg1.json";

import Lottie from "lottie-react";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <header className="header home-header">
      <div className="hero-overlay">
        <Lottie animationData={background} className="backgroundImage" />
      </div>
      <Navbar />
      <HeroSection />
    </header>
  );
}
